import { stringify } from "query-string";
import { compose } from "redux";
import { request } from "../";
import config from "../../../config/common";
import { SEARCH_REQUEST, SEARCH_MVT_PARAMS } from "../constants";
import getSearchBaseUrl from "./getSearchBaseUrl";
import { urlEncodeAllParamsButRefine } from "../../../helpers/urlEncodeAllParamsButRefine";
import dictionaryStringToObject from "../../../helpers/dictionaryStringToObject";

const filterKeys = (obj = {}, allowlist = []) =>
  Object.keys(obj)
    .filter(key => allowlist.includes(key))
    .reduce((a, key) => Object.assign({}, a, { [key]: obj[key] }), {});

const {
  timeout,
  search: searchUrl,
  categories,
  pageSize: limit
} = config.api.product.search;

export const validParams = [
  "q",
  "store",
  "lang",
  "currency",
  "limit",
  "offset",
  "sort",
  "channel",
  "refine",
  "sizeSchema",
  "includeGroups",
  "rowlength",
  "country",
  "keyStoreDataversion",
  "region",
  ...SEARCH_MVT_PARAMS
];

const defaultParams = {
  offset: 0
};

export const sanitiseParams = params => filterKeys(params, validParams);

const makeParamsApiFriendly = params => {
  if (!params.refine) {
    return params;
  }

  const separatedRefineParams = dictionaryStringToObject({
    dictionaryString: params.refine,
    entriesSeparator: "|",
    keyValueSeparator: ":"
  });

  const currentPriceMinMax = separatedRefineParams.currentprice
    ? convertCurrentPriceRefine(separatedRefineParams)
    : {};

  delete params.refine;
  delete separatedRefineParams.currentprice;

  return Object.assign(params, separatedRefineParams, currentPriceMinMax);
};

const convertCurrentPriceRefine = separatedRefineParams => {
  const pricesplit = separatedRefineParams.currentprice.split("<");

  return { priceMin: pricesplit[0], priceMax: pricesplit[1] };
};

const mergeDefaultParams = params =>
  Object.assign({}, defaultParams, params, { limit });

const stringifyParams = object => {
  if (SERVER) {
    return stringify(object, { encode: true });
  }

  return stringify(urlEncodeAllParamsButRefine(object), { encode: false });
};

const getQueryString = compose(
  stringifyParams,
  mergeDefaultParams,
  makeParamsApiFriendly,
  sanitiseParams
);

export const search = (params = {}, uuid, xSiteOriginFromServerRequest) => {
  if (!params.q) {
    const error = new Error("The query string must contain a q parameter");

    return Promise.reject(error);
  }

  const qs = getQueryString(params);
  const url = `${getSearchBaseUrl(
    xSiteOriginFromServerRequest
  )}${searchUrl}?${qs}`;

  return request(url, { timeout }, SEARCH_REQUEST, uuid);
};

export const searchCategory = (
  params = {},
  uuid,
  xSiteOriginFromServerRequest
) => {
  const { cid } = params;
  if (!cid) {
    const error = new Error("The query string must contain a cid parameter");

    return Promise.reject(error);
  }
  const qs = getQueryString(params);
  const url = `${getSearchBaseUrl(
    xSiteOriginFromServerRequest
  )}${categories}/${cid}?${qs}`;

  return request(url, { timeout }, SEARCH_REQUEST, uuid);
};
